import { PostHogProvider } from 'posthog-js/react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppContent } from './AppContent.tsx';
import { CookieBanner } from './components/CookieBanner/CookieBanner.tsx';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary.tsx';
import { getInitialPostHogConfig, POSTHOG_KEY } from './config/posthog.ts';
import { initSentry } from './config/sentry.ts';
import { siteConfig } from './config/siteConfig.ts';
import { LocaleProvider } from './context/Locale/LocaleProvider.tsx';
import { ToastProvider } from './context/Toast/ToastProvider.tsx';
import './index.css';
import './polyfills/promiseWithResolvers.ts';

document.title = siteConfig.appName;
initSentry();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <LocaleProvider>
      <BrowserRouter basename="/">
        <PostHogProvider
          apiKey={POSTHOG_KEY}
          options={getInitialPostHogConfig()}
        >
          <ToastProvider>
            <AppContent />
            <CookieBanner />
          </ToastProvider>
        </PostHogProvider>
      </BrowserRouter>
    </LocaleProvider>
  </ErrorBoundary>
);
